import { useEffect } from "react";

// Closes a modal on Escape. Modals that trap the whole screen must have a
// keyboard way out — mouse-only dismissal locks out keyboard users.
export default function useEscapeKey(active, onEscape) {
  useEffect(() => {
    if (!active) return undefined;
    const handler = (e) => { if (e.key === "Escape") onEscape(); };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [active, onEscape]);
}
